import types from './types';

export const fetchIvrPlans = ({ type }) => ({
  type: types.FETCH_IVR_PLANS,
  payload: { type },
});
export const fetchIvrPlansSuccess = (data) => ({
  type: types.FETCH_IVR_PLANS_SUCCESS,
  payload: data,
});
export const fetchIvrPlansFailure = () => ({
  type: types.FETCH_IVR_PLANS_SUCCESS,
});

export const searchIvrPlanHistory = (params) => ({
  type: types.SEARCH_IVR_PLAN_HISTORY,
  payload: { params },
});
export const searchIvrPlanHistorySuccess = (data) => ({
  type: types.SEARCH_IVR_PLAN_HISTORY_SUCCESS,
  payload: data,
});
export const searchIvrPlanHistoryFailure = () => ({
  type: types.SEARCH_IVR_PLAN_HISTORY_FAILURE,
});

export const selectIvrPlan = ({ id }, callback) => ({
  type: types.SELECT_IVR_PLAN,
  payload: { id, callback },
});
export const selectIvrPlanSuccess = () => ({
  type: types.SELECT_IVR_PLAN_SUCCESS,
});
export const selectIvrPlanFailure = () => ({
  type: types.SELECT_IVR_PLAN_FAILURE,
});

export const fetchIvrPlanConsumptionByMonth = ({ referenceMonth }) => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_MONTH,
  payload: { referenceMonth },
});
export const fetchIvrPlanConsumptionByMonthSuccess = (data) => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_MONTH_SUCCESS,
  payload: data,
});
export const fetchIvrPlanConsumptionByMonthFailure = () => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_MONTH_FAILURE,
});

export const fetchIvrPlanConsumptionByDay = ({ referenceDay }) => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_DAY,
  payload: { referenceDay },
});
export const fetchIvrPlanConsumptionByDaySuccess = (data) => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_DAY_SUCCESS,
  payload: data,
});
export const fetchIvrPlanConsumptionByDayFailure = () => ({
  type: types.FETCH_IVR_PLAN_CONSUMPTION_BY_DAY_FAILURE,
});
